import { render } from "./BlockView.vue?vue&type=template&id=44eed186&scoped=true"
const script = {}

import "./BlockView.vue?vue&type=style&index=0&id=44eed186&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44eed186"]])

export default __exports__